export default class TelegramTopic {
    constructor({
      id,
      title,
      status,
      createdAt,
      publishAt,
      createdBy,
      lastError
    }) {
      this.id = id;
      this.title = title;
      this.status = status; // pending | processing | published | error
      this.createdAt = createdAt;
      this.publishAt = publishAt;
      this.createdBy = createdBy;
      this.lastError = lastError || "";
    }
  
    static fromJson(json) {
      return new TelegramTopic({
        id: json.id,
        title: json.title,
        status: json.status,
        createdAt: json.createdAt,
        publishAt: json.publishAt,
        createdBy: json.createdBy,
        lastError: json.lastError
      });
    }
  
    // 👇 удобные геттеры под UI
    get isPending() {
      return this.status === "pending";
    }
  
    get isPublished() {
      return this.status === "published";
    }
  
    get isError() {
      return this.status === "error";
    }
  }